"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAY_ORDER_WITH_CARD = void 0;
const client_1 = require("@apollo/client");
exports.PAY_ORDER_WITH_CARD = client_1.gql `
  query payOrderWithCard($userRedirectUrl: String! $idOrder: String) {
  payOrderWithCard(userRedirectUrl: $userRedirectUrl idOrder: $idOrder) {
    uri
    method
    headers {
      key
      value
    }
    body
  }
}
`;
